import React from "react";

interface Project {
  id: number;
  title: string;
  description: string;
  technologies: string[];
  url: string;
  imageUrl: string;
  category: string;
}

const Projects: React.FC = () => {
  const projects: Project[] = [
    {
      id: 1,
      title: "Plataforma de E-commerce para Chatbots AI",
      description:
        "Plataforma de comercio electrónico con microservicios, carrito de compras, pasarela de pago y live Chat.",
      technologies: ["React", "Node.js", "Kubernetes", "PostgreSQL", "Redis"],
      url: "https://stateup.anzencode.com",
      imageUrl: "/stateup.jpg",
      category: "Web Development",
    },
    {
      id: 2,
      title: "Landing Page para Anzencode",
      description:
        "Landing page responsiva y optimizada para SEO de la empresa Anzencode.",
      technologies: ["Next.js", "Tailwind CSS", "TypeScript", "Vercel", "Framer Motion"],
      url: "https://anzencode.com",
      imageUrl: "/anzencode.jpg",
      category: "Frontend",
    },
    {
      id: 3,
      title: "Gestor de Infraestructura en la Nube",
      description:
        "Aplicación para gestionar y automatizar despliegues en la nube con infraestructura como código.",
      technologies: ["Terraform", "AWS", "Docker", "React", "Node.js"],
      url: "",
      imageUrl: "/btop.png",
      category: "DevOps",
    },
    {
      id: 4,
      title: "Sistema de Pedidos de Restaurantes en WhatsApp",
      description:
        "Sistema que permite a los clientes hacer pedidos a través de WhatsApp utilizando un chatbot.",
      technologies: ["API de WhatsApp", "Node.js", "Express", "MongoDB", "Dialogflow"],
      url: "https://base.anzencode.com",
      imageUrl: "/pepe.jpg",
      category: "Backend",
    },
    {
      id: 5,
      title: "CRM Para Ventas y Marketing",
      description:
        "CRM personalizado para gestionar clientes, ventas y campañas de marketing.",
      technologies: ["React", "Node.js", "PostgreSQL", "Docker", "Kubernetes"],
      url: "https://crm.anzencode.com",
      imageUrl: "/crm.jpg",
      category: "Full Stack",
    },
    {
      id: 6,
      title: "Acortador de URLs con Análisis",
      description:
        "Acortador de URLs que proporciona análisis detallados de clics y tráfico.",
      technologies: ["React", "Node.js", "MongoDB", "Express", "Chart.js"],
      url: "",
      imageUrl: "/tinyurl.png",
      category: "Web App",
    },
  ];

  // Colores por categoría
  const categoryColors: Record<string, string> = {
    "Web Development": "#2563eb",
    "Frontend": "#16a34a",
    "DevOps": "#7c3aed",
    "Backend": "#ea580c",
    "Full Stack": "#4f46e5",
    "Web App": "#db2777",
  };

  return (
    <>
      {/* ESTILOS CSS PUROS */}
      <style >{`
        .projects-section {
          padding: 5rem 1rem;
          background-color: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }

        .projects-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1rem;
        }

        .projects-title {
          font-size: 2.5rem;
          font-weight: 700;
          text-align: center;
          color: #1f2937;
          margin-bottom: 3rem;
        }

        .projects-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
        }

        @media (min-width: 640px) {
          .projects-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .projects-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 2.5rem;
          }
        }

        .project-card {
          background: white;
          border-radius: 1rem;
          overflow: hidden;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          border: 1px solid #e5e7eb;
          display: flex;
          flex-direction: column;
          height: 100%;
          transition: all 0.3s ease;
        }

        .project-card:hover {
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          transform: translateY(-4px);
        }

        .project-image-container {
          position: relative;
          height: 12rem;
          overflow: hidden;
          background: #f3f4f6;
        }

        .project-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .project-card:hover .project-image {
          transform: scale(1.05);
        }

        .project-category {
          position: absolute;
          top: 0.75rem;
          right: 0.75rem;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.75rem;
          font-weight: 600;
          color: white;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
        }

        .project-content {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .project-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 0.5rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .project-description {
          color: #4b5563;
          font-size: 0.9375rem;
          margin-bottom: 1rem;
          flex: 1;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .project-techs {
          display: flex;
          flex-wrap: wrap;
          gap: 0.375rem;
          margin-bottom: 1rem;
        }

        .project-tech {
          background: #f3f4f6;
          color: #374151;
          font-size: 0.75rem;
          padding: 0.25rem 0.625rem;
          border-radius: 0.375rem;
          font-weight: 500;
        }

        .project-link {
          display: inline-flex;
          align-items: center;
          color: #2563eb;
          font-weight: 600;
          font-size: 0.875rem;
          text-decoration: none;
          margin-top: auto;
        }

        .project-link:hover {
          color: #1d4ed8;
        }

        .project-link svg {
          width: 1rem;
          height: 1rem;
          margin-left: 0.25rem;
          transition: transform 0.2s ease;
        }

        .project-link:hover svg {
          transform: translateX(0.25rem);
        }

        .project-soon {
          color: #9ca3af;
          font-style: italic;
          font-size: 0.875rem;
          margin-top: auto;
        }

        /* Evita scroll horizontal */
        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          overflow-x: hidden;
        }
      `}</style>

      <section id="proyectos" className="projects-section">
        <div className="projects-container">
          <h2 className="projects-title">Proyectos Destacados</h2>

          <div className="projects-grid">
            {projects.map((project) => (
              <article key={project.id} className="project-card">
                {/* Imagen */}
                <div className="project-image-container">
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="project-image"
                    loading="lazy"
                  />
                  <span
                    className="project-category"
                    style={{ backgroundColor: categoryColors[project.category] || "#6b7280" }}
                  >
                    {project.category}
                  </span>
                </div>

                {/* Contenido */}
                <div className="project-content">
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-description">{project.description}</p>

                  {/* Tecnologías */}
                  <div className="project-techs">
                    {project.technologies.slice(0, 3).map((tech, i) => (
                      <span key={i} className="project-tech">
                        {tech}
                      </span>
                    ))}
                    {project.technologies.length > 3 && (
                      <span className="project-tech">
                        +{project.technologies.length - 3}
                      </span>
                    )}
                  </div>

                  {/* Enlace */}
                  {project.url ? (
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      Ver Proyecto
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </a>
                  ) : (
                    <span className="project-soon">Pronto disponible</span>
                  )}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;